'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports["default"] = Marker;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Marker(props) {
  var style = props.style,
      isVisible = props.isVisible;

  var markerStype = _extends({}, style, {
    opacity: isVisible ? 1 : 0
  });

  return _react2["default"].createElement(_RenderIf2["default"], {
    isTrue: isVisible
  }, _react2["default"].createElement('div', {
    className: 'rainbow-radio-button-group_marker-container'
  }, _react2["default"].createElement('span', {
    className: 'rainbow-radio-button-group_marker',
    style: markerStype
  })));
}

Marker.propTypes = {
  style: _propTypes2["default"].object,
  isVisible: _propTypes2["default"].any
};
Marker.defaultProps = {
  style: undefined,
  isVisible: false
};